import { render, staticRenderFns } from "./BaseImageWithScore.vue?vue&type=template&id=f61cec5a&"
import script from "./BaseImageWithScore.vue?vue&type=script&lang=js&"
export * from "./BaseImageWithScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports